import { LANG } from 'common/constants';

import intlEn from './en';

const locales = {
  [LANG.EN]: intlEn,
};

export default locales;
